/*
 * @providesModule SKZTournamentCategories
 */

import {SKZGameMode, SKZGameModeRecord} from 'SKZGameMode';
import SKZTournament, {TournamentRecord, TournamentCategoryType} from 'SKZTournament';
import SKZTournamentTemplateSet, {SKZTournamentTemplateSetRecord} from 'SKZTournamentTemplateSet';

export interface SKZTournamentCategoryRecord {
  name: string;
  description: string;
  type: TournamentCategoryType;
  highlight_text: string | null;
  tournaments: TournamentRecord[] | null;
  game_modes: SKZGameMode;
  tournament_template_sets: SKZTournamentTemplateSetRecord[] | null;
  live_events: TournamentRecord[] | null;
}

export interface GroupedTournamentTemplatesResponse {
  categories: SKZTournamentCategoryRecord[]
}

export class SKZTournamentCategory {
  name: string;
  description: string;
  type: TournamentCategoryType;
  highlight_text: string | null;
  tournaments: SKZTournament[] | null;
  game_modes: SKZGameMode[];
  tournament_template_sets: SKZTournamentTemplateSet[] | null;
  live_events: SKZTournament[] | null;

  constructor(category: SKZTournamentCategoryRecord) {
    this.name = category.name;
    this.description = category.description;
    this.type = category.type;
    this.highlight_text = category.highlight_text;
    this.tournaments = category.tournaments?.map((tournament) => new SKZTournament(tournament)) ?? null;
    this.game_modes = category.game_modes?.map((gameMode: SKZGameModeRecord) => new SKZGameMode(gameMode)) ?? null;
    this.tournament_template_sets = category.tournament_template_sets?.map((tournament) => new SKZTournamentTemplateSet(tournament)) ?? null;
    this.live_events = category.live_events?.map((tournament) => new SKZTournament(tournament)) ?? null;
  }
}

export default class SKZTournamentCategories {
  categories: SKZTournamentCategory[];

  constructor(serverCategories: GroupedTournamentTemplatesResponse) {
    this.categories = serverCategories.categories?.map((category) => new SKZTournamentCategory(category));
  }

  getCategoryForType(categoryType: TournamentCategoryType): SKZTournamentCategory | null {
    return this.categories.find((category) => category.type == categoryType) ?? null;
  }

  hasTournamentById(tournamentId: string): boolean {
    for (const category of this.categories) {
      if (category.game_modes !== [] && category.game_modes) {
        for (const gameMode of category.game_modes) {  
          if (gameMode.tournaments.find((tournament: SKZTournament) => tournament.id == tournamentId)) {  
            return true;
          }
        }
      }
    }
    return false;
  }

  getTournamentById(tournamentId: string): SKZGameMode {
    for (const category of this.categories) {
      if (category.game_modes !== [] && category.game_modes) {
        for (const gameMode of category.game_modes) {
          if (gameMode.tournaments.find((tournament: SKZTournament) => tournament.id == tournamentId)) {
            return gameMode;
          }
        }
      }
    }
    return null;
  }
  
}
